export default "__VITE_ASSET__CEIAZ4M9__"